// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_criarSenha {
  display: flex;
  width: 100%;
  max-height: 100%;
}

.caixa_img_criarSenha {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33rem;
  height: 94vh;
  margin-top: 3%;
  margin-left: 50%;
  display: absolute;
  border-radius: 30px 30px 0px 0px;
  background-color: var(--cor-roxoApoio);
}

.caixa_img_criarSenha img {
  width: 95%;
}

.form {
  width: 25vw;
  position: absolute;
  left: 15%;
  top: 4%;
  margin-top: 6em;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Inter";
}

.form h3 {
  color: var(--cor-preto);
  text-align: center;
  margin-right: 2em;
  padding: 1em;
  font-size: 18px;
}

.form label {
  color: var(--cor-preto);
  align-self: flex-start;
  text-align: left;
  font-size: 14px;
  padding: 1em 1em 0.3em 0;
}

.inputSenha {
  padding: 0.5em;
}

.logo_conexao {
  width: 55%;
}

.btnConfirmar {
  background-color: var(--cor-roxoEscuro);
  color: var(--cor-branco);
  border: none;
  border-radius: 0.5rem;
  width: 100%;
  height: 3rem;
  margin-top: 2rem;
  font-size: 17px;
  cursor: pointer;
}

.form p {
  color: var(--cor-vermelho);
  margin-top: 5%;
  font-size: 12px;
  align-self: flex-start;
  text-align: left;
}

.container_criarSenha span {
  color: var(--cor-pretoFraco);
}

.instituto_span {
  display: flex;
  flex-direction: row;
  margin-top: 15% ;
  font-size: 14px;
  color: var(--cor-preto);
}

.instituto_span img{
  text-align: center;
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/paginas/CriarSenha.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".container_criarSenha {\n  display: flex;\n  width: 100%;\n  max-height: 100%;\n}\n\n.caixa_img_criarSenha {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 33rem;\n  height: 94vh;\n  margin-top: 3%;\n  margin-left: 50%;\n  display: absolute;\n  border-radius: 30px 30px 0px 0px;\n  background-color: var(--cor-roxoApoio);\n}\n\n.caixa_img_criarSenha img {\n  width: 95%;\n}\n\n.form {\n  width: 25vw;\n  position: absolute;\n  left: 15%;\n  top: 4%;\n  margin-top: 6em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: \"Inter\";\n}\n\n.form h3 {\n  color: var(--cor-preto);\n  text-align: center;\n  margin-right: 2em;\n  padding: 1em;\n  font-size: 18px;\n}\n\n.form label {\n  color: var(--cor-preto);\n  align-self: flex-start;\n  text-align: left;\n  font-size: 14px;\n  padding: 1em 1em 0.3em 0;\n}\n\n.inputSenha {\n  padding: 0.5em;\n}\n\n.logo_conexao {\n  width: 55%;\n}\n\n.btnConfirmar {\n  background-color: var(--cor-roxoEscuro);\n  color: var(--cor-branco);\n  border: none;\n  border-radius: 0.5rem;\n  width: 100%;\n  height: 3rem;\n  margin-top: 2rem;\n  font-size: 17px;\n  cursor: pointer;\n}\n\n.form p {\n  color: var(--cor-vermelho);\n  margin-top: 5%;\n  font-size: 12px;\n  align-self: flex-start;\n  text-align: left;\n}\n\n.container_criarSenha span {\n  color: var(--cor-pretoFraco);\n}\n\n.instituto_span {\n  display: flex;\n  flex-direction: row;\n  margin-top: 15% ;\n  font-size: 14px;\n  color: var(--cor-preto);\n}\n\n.instituto_span img{\n  text-align: center;\n  margin-left: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
